/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from "react";
import {
  Form,
  FormGroup,
  Label,
  ListGroup,
  ListGroupItem,
  Spinner,
  Row,
  Col,
} from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import PropTypes from "prop-types";

import { ArchiveTypes } from "../../Account/types";
import ModalArchive from "../../Modal/ModalArchive";
import ModalConfirm from "../../Modal/ModalConfirm";
import ModalError from "../../Modal/ModalError";
import { PersonType } from "../types";
import { getLocalDate } from "../../../../utils";
import { FormattedDate } from "react-intl";
import { showToast } from "../../../../utils/Helper";

const ArchivesTab = ({
  person,
  archives,
  setPersonData,
  archivesTypes,
  services,
  onboarding,
  refresh,
  userSession
}) => {
  const [modalArchives, setModalArchives] = useState({
    open: false,
    loading: false,
  });
  const [modalConfirm, setModalConfirm] = useState({
    open: false,
    title: "",
    callback: undefined,
    loading: false,
  });
  const [modalError, setModalError] = useState({
    open: false,
    message: "",
  });

  const toggleModalError = (e, message) => {
    setModalError({
      open: !modalError.open,
      message,
    });
  };

  const handleSaveFile = (archive) => {
    if (
      ["pdf", "jpeg", "jpg", "png", "csv", "doc", "docx", "xls", "xlsx"].includes(
        archive.ArchivesExtension.toLowerCase()
      )
    ) {
      const newArchive = {};
      Object.keys(archive).forEach((key) => {
        newArchive[`Person${key}`] = archive[key];
      });

      const body = {
        person: {
          PersonId: person.PersonId,
          Archives: [newArchive],
        },
        file: true,
        remove: false,
      };
      setModalArchives((m) => ({
        ...m,
        loading: true,
      }));
      if (onboarding) {
        let docs = person.Archives;
        //get the last id
        let id = 0;
        person.Archives.forEach((p, i) => {
          if (p.PersonArchiveId > id) {
            id = p.PersonArchiveId + 1;
          }
        });
        if (newArchive.PersonArchiveId > 0) {
          id = newArchive.ArchiveId;
          docs.forEach((p, i) => {
            if (p.PersonArchiveId == newArchive.PersonArchiveId) {
              docs.splice(i, 1);
            }
          });
        }
        const nArchive = {
          ...newArchive,
          PersonArchiveId: id,
        };

        docs.push(nArchive);
        const postPerson = {
          ...person,
          Archives: docs,
        };
        const body2 = {
          postPerson: postPerson,
          OnboardingId: onboarding,
        };

        services.fetchNewPerson(body2, (response) => {
          if (response && response.result && response.result.Code === 200) {
            setPersonData(body2.postPerson);
            setModalArchives({
              open: false,
              loading: false,
            });
            refresh();
          } else {
            console.log("response append doc", response);
          }
        });
      } else {
        const updatedBody = {
          ...body, 
          person: {
            ...body.person, 
            isOnboardingPerson: person.isOnboardingPerson,
          },
        };
        services.fetchAppendPersonNewDocument(updatedBody, (response) => {
          if (response && response.result && response.result.Code === 200) {
            const newDocument = body.person.Archives[0];
            newDocument.PersonArchiveId = response.Id;
            const newArchives = [...archives];
            newArchives.push(newDocument);
            setModalArchives({
              open: false,
              loading: false,
            });
            setPersonData({
              ...person,
              Archives: newArchives,
            });
          } else {
            toggleModalError(
              {},
              response && response.result
                ? `Error saving Archive: ${response.result.Description}`
                : "Server Error"
            );
            setModalArchives({
              open: false,
              loading: false,
            });
          }
        });
      }
    } else {
      showToast(
        "error: the file must be pdf, csv, doc, docx, xls or xlsx",
        true
      );
      setModalArchives({
        open: true,
        loading: false,
      });
    }
  };

  const handleDeleteFile = (archiveId) => {
    const body = {
      person: {
        PersonId: person.PersonId,
        Archives: [
          {
            PersonArchiveId: archiveId,
          },
        ],
      },
      file: true,
      remove: true,
    };
    setModalConfirm((m) => ({
      ...m,
      loading: true,
    }));
    if (onboarding) {
      let docs = person.Archives;
      docs.forEach((p, i) => {
        if (p.PersonArchiveId == archiveId) {
          docs.splice(i, 1);
        }
      });
      const postPerson = {
        ...person,
        Archives: docs,
      };
      const body2 = {
        postPerson: postPerson,
        OnboardingId: onboarding,
      };
      services.fetchNewPerson(body2, (response) => {
        if (response && response.result && response.result.Code === 200) {
          setPersonData(body2.postPerson);
          setModalConfirm({
            open: false,
            title: "",
            callback: undefined,
            loading: false,
          });
          refresh();
        } else {
          //alert("Server Error")
        }
      });
    } else {
      const updatedBody = {
        ...body, 
        person: {
          ...body.person, 
          isOnboardingPerson: person.isOnboardingPerson,
        },
      };
      services.fetchAppendPersonNewDocument(updatedBody, (response) => {
        if (response && response.result && response.result.Code === 200) {
          let index = -1;
          const newArchives = [...archives];
          newArchives.forEach((doc, i) => {
            if (parseInt(doc.PersonArchiveId, 10) === parseInt(archiveId, 10)) {
              index = i;
            }
          });
          if (index > -1) {
            newArchives.splice(index, 1);
          }
          setModalConfirm({
            open: false,
            title: "",
            callback: undefined,
            loading: false,
          });
          setPersonData({
            ...person,
            Archives: newArchives,
          });
        } else {
          toggleModalError(
            {},
            response && response.result
              ? `Error saving Archive: ${response.result.Description}`
              : "Server Error"
          );
          setModalArchives({
            open: false,
            loading: false,
          });
        }
      });
    }
  };

  const handleEnableFile = (archive) => {
    setModalConfirm((m) => ({
      ...m,
      loading: true,
    }));

    if (onboarding) {
      let docs = person.Archives;
      let id = Number(archives.length) + 2;
      if (archive.PersonArchiveId > 0) {
        id = archive.ArchiveId;
        docs.forEach((p, i) => {
          if (p.PersonArchiveId == archive.PersonArchiveId) {
            docs.splice(i, 1);
          }
        });
      }
      const nArchive = {
        ...archive,
        PersonArchiveId: id,
        PersonArchivesEnabled: !archive.PersonArchivesEnabled,
      };

      docs.push(nArchive);
      const postPerson = {
        ...person,
        Archives: docs,
      };
      const body2 = {
        postPerson: postPerson,
        OnboardingId: onboarding,
      };

      services.fetchNewPerson(body2, (response) => {
        if (response && response.result && response.result.Code === 200) {
          setPersonData(body2.postPerson);
          setModalArchives({
            open: false,
            loading: false,
          });
          setModalConfirm({
            open: false,
            title: "",
            callback: undefined,
            loading: false,
          });
          refresh();
        }
      });
    } else {
      const newArchive = {
        ...archive,
        PersonArchivesEnabled: !archive.PersonArchivesEnabled,
      };
      const body = {
        person: {
          PersonId: person.PersonId,
          Archives: [newArchive],
          isOnboardingPerson: person.isOnboardingPerson,
        },
        file: true,
        remove: false,
      };
      setModalArchives((m) => ({
        ...m,
        loading: true,
      }));
      services.fetchAppendPersonNewDocument(body, (response) => {
        if (response && response.result && response.result.Code === 200) {
          let index = -1;
          const newArchives = [...archives];
          newArchives.forEach((doc, i) => {
            if (
              parseInt(doc.PersonArchiveId, 10) ===
              parseInt(archive.PersonArchiveId, 10)
            ) {
              index = i;
            }
          });
          if (index > -1) {
            newArchives.splice(index, 1);
          }
          newArchives.push(newArchive);
          setModalArchives({
            open: false,
            loading: false,
          });
          setModalConfirm({
            open: false,
            title: "",
            callback: undefined,
            loading: false,
          });
          setPersonData({
            ...person,
            Archives: newArchives,
          });
        } else {
          toggleModalError(
            {},
            response && response.result
              ? `Error saving Archive: ${response.result.Description}`
              : "Server Error"
          );
          setModalArchives({
            open: false,
            loading: false,
          });
        }
      });
    }
  };

  const toggleModalConfirm = (id, action) =>
    setModalConfirm((m) => {
      const newM = {
        ...m,
        open: !m.open,
      };
      if (id && action === "del") {
        newM.title = "Are you sure you want to remove the selected Archive?";
        newM.callback = () => handleDeleteFile(id);
      }
      if (id && action === "enable") {
        newM.title = "Are you sure you want to enable the selected Archive?";
        newM.callback = () => handleEnableFile(id);
      }
      if (id && action === "desable") {
        newM.title = "Are you sure you want to disable the selected Archive?";
        newM.callback = () => handleEnableFile(id);
      }
      return newM;
    });

  const toggleModalDoc = () => {
    const archiveSubytpeExists =
      Object.keys(archivesTypes[ArchiveTypes.Person]).length > 0 &&
      Object.keys(archivesTypes[ArchiveTypes.Person].ArchivesSubTypes).length >
        0;
    if (archiveSubytpeExists) {
      setModalArchives((m) => ({
        open: !m.open,
        loading: false,
      }));
    } else {
      alert(
        "No Archives Subtypes entered in the system.\nTo add files go to:\nParameteres -> Archive Subtypes"
      );
    }
  };

  if (!archives || !archivesTypes) {
    return <Spinner />;
  }
  const getFile = (file) => {
    const body = {
      personId: person.PersonId,
      fileId: file.PersonArchiveId,
    };
    services.fetchPersonFile(body, (response) => {
      var a = document.createElement("A");
      a.href = `data:application/octet-stream;base64,${response.blobfile}`;
      a.download = `${file.PersonArchivesName}.${file.PersonArchivesExtension}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  };

  const getOnboardingFile = (file) => {
    const body = {
      personid: person.PersonId,
      fileid: file.PersonArchiveId,
      onboarding: onboarding,
    };
    services.fetchOnboardingPersonFile(body, (response) => {
      var a = document.createElement("A");
      a.href = `data:application/octet-stream;base64,${response.blobfile}`;
      a.download = `${file.PersonArchivesName}.${file.PersonArchivesExtension}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  };

  return (
    <div>
      <Form>
        <FormGroup tag="fieldset">
          <ListGroup>
            {archives.map((d, i) => (
              <ListGroupItem key={d.PersonArchiveId}>
                <Label>
                  <span style={{ fontSize: "15px", fontWeight: 500 }}>
                    {d.PersonArchivesSubTypeDescription}
                    {":   "}
                  </span>
                  <i
                    className={
                      d.PersonArchivesExtension === "pdf"
                        ? "fa fa-file-pdf-o"
                        : "fa fa-file"
                    }
                  />
                  {!onboarding ? (
                    <a
                      onClick={() => getFile(d)}
                      style={{
                        cursor: "pointer",
                      }} /*href={`data:application/octet-stream;base64,${d.PersonArchivesBlob}`} download={`${d.PersonArchivesName}.${d.PersonArchivesExtension}`}*/
                    >
                      {" "}
                      {d.PersonArchivesName}
                    </a>
                  ) : (
                    <a
                      onClick={() => getOnboardingFile(d)}
                      style={{
                        cursor: "pointer",
                      }} /*href={`data:application/octet-stream;base64,${d.PersonArchivesBlob}`} download={`${d.PersonArchivesName}.${d.PersonArchivesExtension}`}*/
                    >
                      {" "}
                      {d.PersonArchivesName}
                    </a>
                  )}

                  {d.PersonArchivesHasExpirationDate ? (
                    <Row>
                      <Col>
                        <span style={{ fontSize: "15px", fontWeight: 500 }}>
                          {"Expiration Date: "}
                          <FormattedDate
                            value={
                              d.PersonArchivesExpirationDate.indexOf("T") > -1
                                ? d.PersonArchivesExpirationDate
                                : d.PersonArchivesExpirationDate + "T00:00"
                            }
                          />
                        </span>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col>
                        <span style={{ fontSize: "15px", fontWeight: 500 }}>
                          {"LifeLong: "}
                          {"Yes"}
                        </span>
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col>
                      <span style={{ fontSize: "15px", fontWeight: 500 }}>
                        {"Enabled: "}
                        {d.PersonArchivesEnabled ? "Yes" : "No"}
                      </span>
                    </Col>
                  </Row>
                </Label>
                {userSession.IsReadOnly === false && <div
                  style={{ cursor: "pointer", float: "right" }}
                  onClick={() => toggleModalConfirm(d.PersonArchiveId, "del")}
                >
                  <i className="fa fa-trash" />
                </div>}
                {userSession.IsReadOnly === false && <div
                  style={{
                    cursor: "pointer",
                    float: "right",
                    paddingRight: "10px",
                  }}
                  onClick={() =>
                    toggleModalConfirm(
                      d,
                      d.PersonArchivesEnabled ? "desable" : "enable"
                    )
                  }
                >
                  {d.PersonArchivesEnabled ? (
                    <i className="fa fa-chain-broken" />
                  ) : (
                    <i className="fa fa-link" />
                  )}
                </div>}
              </ListGroupItem>
            ))}
          </ListGroup>
        </FormGroup>
      </Form>
      {userSession.IsReadOnly === false && <LaddaButton
        className="btn btn-ladda btn-primary"
        loading={false}
        style={{ marginRight: 10 }}
        onClick={toggleModalDoc}
        data-style={EXPAND_RIGHT}
      >
        <i className="fa fa-plus" /> Add New Archive
      </LaddaButton>}
      {modalArchives.open && (
        <ModalArchive
          {...modalArchives}
          archiveType={
            person.PersonType === PersonType.Physical
              ? archivesTypes[ArchiveTypes.Person]
              : archivesTypes[ArchiveTypes.Company]
          }
          onSave={handleSaveFile}
          onToggle={toggleModalDoc}
        />
      )}
      <ModalConfirm
        open={modalConfirm.open}
        toggle={toggleModalConfirm}
        saving={modalConfirm.loading}
        callback={modalConfirm.callback}
        title={modalConfirm.title}
      />
      <ModalError {...modalError} onToggle={toggleModalError} />
    </div>
  );
};

ArchivesTab.propTypes = {
  person: PropTypes.object.isRequired,
  services: PropTypes.object.isRequired,
  setPersonData: PropTypes.func.isRequired,
  archivesTypes: PropTypes.object,
  archives: PropTypes.array,
};

ArchivesTab.defaultProps = {
  archivesTypes: undefined,
  archives: undefined,
};

export default ArchivesTab;
